// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { StarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// project imports
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import LanguageSwitcher from './LanguageSwitcher';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>

      <Box sx={{ flexGrow: 1 }} />
      {!downLG && (
        <Button
          variant="contained"
          color="primary"
          size="medium"
          startIcon={<StarOutlined />}
          onClick={() => navigate('/events/wizard')}
          sx={{ ml: 1 }}
        >
          {t('header.wizard')}
        </Button>
      )}
      {downLG && (
        <Button
          variant="contained"
          color="primary"
          size="medium"
          startIcon={<StarOutlined />}
          onClick={() => navigate('/events/wizard')}
          sx={{ ml: 1 }}
        >
          {t('header.wizard')}
        </Button>
      )}
      <LanguageSwitcher />
      <Notification />
      <Profile />

    </>
  );
}
